import { render } from "./LoginView.vue?vue&type=template&id=c2f2286e&scoped=true&lang=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=c2f2286e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f2286e"]])

export default __exports__